import { type AvailableLocales, LOCALES } from '@consts/locales.const';

export function getInitialLocale(): AvailableLocales {
  const navigatorLocales = navigator.languages.map((locale) => locale.substring(0, 2));
  const initialLocale = navigatorLocales.find((locale) => LOCALES[locale]);
  return (initialLocale || LOCALES.en) as AvailableLocales;
}
